// 图片懒加载

function isInSight(el) {
  const bound = el.getBoundingClientRect();
  const clientHeight = window.innerHeight;
  return bound.top <= clientHeight + 100;
};

function loadImg(el) {
  if (isZmlazyloaded(el)) {
    return;
  }

  addLoadMark(el);

  const source = getImgByResolutionRatio(el);

  el.src = source;

  el.onload = () => {
    reoveLazyLoad(el);
  };
};

function isZmlazyloaded(el) {
  return (el.getAttribute('zmlazyload') === 'zmlazyloaded');
};

function addLoadMark(el) {
  el.setAttribute('zmlazyload', 'zmlazyloaded');
};

function getImgByResolutionRatio(el) {
  if (!window.devicePixelRatio) {
    return el.dataset.src;
  }

  if (el.dataset.fit !== 'fit') {
    return el.dataset.src;
  }

  if (window.devicePixelRatio < 3) {
    return el.dataset.src;
  }

  let imgUrl = el.dataset.src;
  let lastPointIndex = imgUrl.lastIndexOf('.');
  let suffix = imgUrl.slice(lastPointIndex, a.length);
  let threeReg = new RegExp('(' + suffix + ')$', 'g');
  let threeRateImg = imgUrl.replace(threeReg, '@3x$1');

  return threeRateImg;
};

function reoveLazyLoad (el) {
  el.removeAttribute('zmlazyload');
};


/* 方法说明 我们根据属性zmlazyload来标记该图片是否需要进行懒加载,这意味两件事情:
 * 1-如果你不希望该图片执行懒加载,不需要加这个属
 * 2-如果该图片已经执行了懒加载,该属性会被移除
 * @method checkImgs
 */
function checkImgs() {
  const imgs = document.querySelectorAll('img[zmlazyload]');

  Array.from(imgs).forEach(el => {
    if (isInSight(el)) {
      loadImg(el);
    }
  });
};

function throttle(fn, mustRun = 500) {
  let previous = null;

  return function () {
    const now = new Date();
    const context = this;
    const args = arguments;

    if (!previous){
      previous = now;
    }

    const remaining = now - previous;

    if (mustRun && remaining >= mustRun) {

      fn.apply(context, args);
      previous = now;

    }
  };
};

function init() {
  checkImgs();

  window.removeEventListener('scroll', throttle(checkImgs));
  window.addEventListener('scroll', throttle(checkImgs), false);
}

const lazyImgInit = () => {
  window.setTimeout(() => {
    init();
  }, 0);
};

/* 图片懒加载使用：
 * 1-img元素,添加zmlazyload属性表示懒加载
 * 2-img元素设置data-src属性, 值是真正的图片的地址(不加2x后缀)
 * 3-img元素设置data-fit属性 标记是否使用图片自适应模式，即自动根据分辨率在合适的时机加载3x图
 * @method checkImgs
 */
export default {
  lazyImgInit,
};

